import { render } from "./MenuPage.vue?vue&type=template&id=14d12f3a"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=14d12f3a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__